import BoldSmallText from '@/components/BoldSmallText';
import RegularText from '@/components/RegularText';
import { SETTING_TYPE } from '@/constants/enum';
import { StyledSortBox } from '@/pages/WidgetAppearance/styled';
import { handleSaveWidgetSettings, widgetSettingSelector } from '@/redux/slice/widget.slice';
import { BlockStack, Box, Icon, Select, Tooltip } from '@shopify/polaris';
import { DragDropIcon } from '@shopify/polaris-icons';
import { useCallback, useMemo } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

export const WidgetDesignAdavanced = () => {
  const { t } = useTranslation('widget_settings');
  const widgetSettings = useSelector(widgetSettingSelector);
  const dispatch = useDispatch();

  const selectMethodOptions = useMemo(() => {
    return [
      { label: t('widgetDesign.advanced.selectMethodOptions.0'), value: SETTING_TYPE.PICKUP },
      { label: t('widgetDesign.advanced.selectMethodOptions.1'), value: SETTING_TYPE.DELIVERY },
      { label: t('widgetDesign.advanced.selectMethodOptions.2'), value: SETTING_TYPE.SHIPPING },
    ];
  }, [t]);

  const handleDragEnd = useCallback(
    (result: any) => {
      const { source, destination } = result;

      if (!destination) {
        return;
      }

      const reorderedItems = Array.from(widgetSettings.sortMethods);
      const [movedItem] = reorderedItems.splice(source.index, 1);
      reorderedItems.splice(destination.index, 0, movedItem);

      dispatch(handleSaveWidgetSettings({ sortMethods: reorderedItems }));
    },
    [dispatch, widgetSettings.sortMethods],
  );

  return (
    <Box padding={'300'}>
      <BlockStack gap={'300'}>
        <BoldSmallText>{t('widgetDesign.advanced.title')}</BoldSmallText>
        <BlockStack gap={'100'}>
          <Tooltip content={t('widgetDesign.advanced.sortTooltip')}>
            <RegularText fontWeight="medium">{t('widgetDesign.advanced.sortTitle')}</RegularText>
          </Tooltip>
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="columns" direction="horizontal">
              {(provided) => (
                <div
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  {widgetSettings.sortMethods.map((item, index) => (
                    <Draggable key={item} draggableId={item} index={index}>
                      {(provided) => (
                        <StyledSortBox ref={provided.innerRef} {...provided.draggableProps}>
                          <div style={{ backgroundColor: '#ebebeb', padding: '8px' }} {...provided.dragHandleProps}>
                            <Icon source={DragDropIcon} />
                          </div>
                          {t(`widgetDesign.advanced.sortOptions.${item}`)}
                        </StyledSortBox>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </BlockStack>
      </BlockStack>
    </Box>
  );
};
